import { useRef, useState, useCallback } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

export default function BeforeAfterSlider({ before, after, beforeLabel = "ÖNCE", afterLabel = "SONRA", alt = "Öncesi ve sonrası", aspect = "16 / 10" }) {
  const [pos, setPos] = useState(50);
  const ref = useRef(null);
  const dragging = useRef(false);

  const updateFromClientX = useCallback((clientX) => {
    const el = ref.current;
    if (!el) return;
    const rect = el.getBoundingClientRect();
    const x = Math.min(Math.max(clientX - rect.left, 0), rect.width);
    setPos((x / rect.width) * 100);
  }, []);

  const onDown = (e) => {
    dragging.current = true;
    const clientX = e.touches ? e.touches[0].clientX : e.clientX;
    updateFromClientX(clientX);
  };
  const onMove = (e) => {
    if (!dragging.current) return;
    const clientX = e.touches ? e.touches[0].clientX : e.clientX;
    updateFromClientX(clientX);
  };
  const onUp = () => {
    dragging.current = false;
  };

  return (
    <div
      ref={ref}
      data-testid="before-after-slider"
      className="relative w-full select-none overflow-hidden rounded-none border border-white/15 bg-neutral-900"
      style={{ aspectRatio: aspect }}
      onMouseDown={onDown}
      onMouseMove={onMove}
      onMouseUp={onUp}
      onMouseLeave={onUp}
      onTouchStart={onDown}
      onTouchMove={onMove}
      onTouchEnd={onUp}
    >
      <img src={`${after}?w=960`} alt={`${alt} - sonra`} className="absolute inset-0 h-full w-full object-cover" loading="lazy" decoding="async" draggable={false} />
      <span className="absolute right-4 top-4 z-10 rounded-none border border-gold/40 bg-black/70 px-3 py-1 font-oswald text-[11px] font-bold tracking-[0.2em] text-gold backdrop-blur">{afterLabel}</span>

      <div className="absolute inset-0 overflow-hidden" style={{ width: `${pos}%` }}>
        <img
          src={before}
          alt={`${alt} - önce`}
          className="absolute inset-0 h-full w-full max-w-none object-cover"
          style={{ width: ref.current ? ref.current.getBoundingClientRect().width : "100%" }}
          loading="lazy"
          draggable={false}
        />
        <span className="absolute left-4 top-4 z-10 rounded-none border border-white/20 bg-black/70 px-3 py-1 font-oswald text-[11px] font-bold tracking-[0.2em] text-white backdrop-blur">{beforeLabel}</span>
      </div>

      {/* 1px gold divider with sharp diamond handle */}
      <div className="absolute inset-y-0 z-20 w-px bg-gold shadow-[0_0_16px_rgba(247,195,0,0.6)]" style={{ left: `${pos}%` }}>
        <div className="absolute left-1/2 top-1/2 flex h-11 w-11 -translate-x-1/2 -translate-y-1/2 rotate-45 cursor-ew-resize items-center justify-center border border-gold bg-black/85 backdrop-blur">
          <span className="flex -rotate-45 items-center text-gold">
            <ChevronLeft className="h-3.5 w-3.5 -mr-1" />
            <ChevronRight className="h-3.5 w-3.5 -ml-1" />
          </span>
        </div>
      </div>
    </div>
  );
}
